/* By Bloom - Custom JS */

(function () {

  var KLEUREN = ['Groen', 'Roze', 'Zwart'];
  var BADGE_TEXT = 'Meest gekozen';
  var BADGE_CLASS = 'variant-badge-popular';
  var POPULAR_ATTR = 'data-popular';

  var VARIANT_IDS_2STUKS = {
    'Groen':   '53839838609747',
    'Roze':    '53839838642515',
    'Zwart':   '53839838675283',
    'Gemengd': '53856076366163'
  };

  // Globale staat — onafhankelijk van picker-herinitialisatie
  var _state = { active: false, k1: '', k2: '' };

  // ============================================================
  // FormData patch — onderschept new FormData(form)
  // ============================================================

  var _OrigFormData = window.FormData;
  function PatchedFormData(form) {
    var fd = form ? new _OrigFormData(form) : new _OrigFormData();
    if (form instanceof HTMLElement) {
      var override = getOverride();
      if (override) {
        fd.set('id', override.variantId);
        fd.set('properties[Kleur 1]', override.k1);
        fd.set('properties[Kleur 2]', override.k2);
      }
    }
    return fd;
  }
  PatchedFormData.prototype = _OrigFormData.prototype;
  window.FormData = PatchedFormData;

  // Fetch backup
  var _origFetch = window.fetch;
  window.fetch = function (url, options) {
    var urlStr = url ? url.toString() : '';
    if (urlStr.indexOf('/cart/add') !== -1 && options && options.body instanceof _OrigFormData) {
      var override = getOverride();
      if (override) {
        options.body.set('id', override.variantId);
        options.body.set('properties[Kleur 1]', override.k1);
        options.body.set('properties[Kleur 2]', override.k2);
      }
    }
    return _origFetch.apply(this, arguments);
  };

  function getOverride() {
    if (!_state.active || !_state.k1 || !_state.k2) return null;
    var targetKleur = (_state.k1 === _state.k2) ? _state.k1 : 'Gemengd';
    var variantId = VARIANT_IDS_2STUKS[targetKleur];
    if (!variantId) return null;
    return { variantId: variantId, k1: _state.k1, k2: _state.k2 };
  }

  // ============================================================
  // Hulpfuncties
  // ============================================================

  var _pickerCounter = 0;
  function getPickerId(picker) {
    if (!picker.dataset.bybloomId) {
      picker.dataset.bybloomId = 'bb' + (++_pickerCounter);
    }
    return picker.dataset.bybloomId;
  }

  function findFieldsets(picker) {
    var kleurFs = null;
    var aantalFs = null;
    picker.querySelectorAll('fieldset').forEach(function (fs) {
      fs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        var val = (inp.value || '').trim();
        if (val.indexOf('stuk') !== -1) aantalFs = fs;
        if (KLEUREN.indexOf(val) !== -1 || val === 'Gemengd') kleurFs = fs;
      });
    });
    return { kleurFs: kleurFs, aantalFs: aantalFs };
  }

  function findProductForm(picker) {
    var el = picker.parentElement;
    while (el) {
      if (el.tagName === 'FORM' && el.action) return el;
      el = el.parentElement;
    }
    return null;
  }

  function hideGemengdOption(fs) {
    if (!fs.kleurFs) return;
    var radio = fs.kleurFs.querySelector('input[type="radio"][value="Gemengd"]');
    if (!radio) return;
    var wrapper = radio.closest('li') || radio.closest('[class*="item"]') || radio.parentElement;
    if (wrapper) wrapper.style.display = 'none';
  }

  // ============================================================
  // Badge: "Meest gekozen"
  // ============================================================

  function injectBadgesForPicker(picker) {
    picker.querySelectorAll('.variant-option__button-label[' + POPULAR_ATTR + '="true"]').forEach(function (label) {
      var fieldset = label.closest('fieldset');
      if (!fieldset) return;
      if (fieldset.querySelector('.' + BADGE_CLASS)) return;

      fieldset.style.paddingTop = '24px';
      fieldset.style.overflow = 'visible';
      if (!fieldset.style.position) fieldset.style.position = 'relative';

      var badge = document.createElement('span');
      badge.className = BADGE_CLASS;
      badge.textContent = BADGE_TEXT;

      var legend = fieldset.querySelector('legend');
      if (legend && legend.nextSibling) {
        fieldset.insertBefore(badge, legend.nextSibling);
      } else {
        fieldset.appendChild(badge);
      }

      function positionBadge() {
        var labelRect = label.getBoundingClientRect();
        var fieldsetRect = fieldset.getBoundingClientRect();
        badge.style.left = (labelRect.left - fieldsetRect.left + labelRect.width / 2) + 'px';
      }
      positionBadge();
      window.addEventListener('resize', positionBadge);
    });
  }

  // ============================================================
  // Twee kleurkiezers
  // ============================================================

  function buildTwoColorHTML() {
    function row(n) {
      var btns = KLEUREN.map(function (k) {
        return '<button type="button" class="bybloom-kleur-btn" data-group="' + n + '" data-kleur="' + k + '">' + k + '</button>';
      }).join('');
      return '<div class="bybloom-kleur-rij"><span class="bybloom-kleur-label">Kleur ' + n + '</span>'
           + '<div class="bybloom-kleur-knoppen">' + btns + '</div></div>';
    }
    return row('1') + row('2');
  }

  function syncVisibilityForPicker(picker) {
    var pid = getPickerId(picker);
    var fs  = findFieldsets(picker);
    var ui  = document.getElementById('bybloom-twee-kleuren-' + pid);
    if (!fs.kleurFs || !fs.aantalFs || !ui) return;

    hideGemengdOption(fs);

    var checked  = fs.aantalFs.querySelector('input[type="radio"]:checked');
    var is2stuks = checked && checked.value.indexOf('2 stuks') !== -1;

    fs.kleurFs.style.display = is2stuks ? 'none' : '';
    ui.style.display          = is2stuks ? ''     : 'none';

    _state.active = is2stuks;
    if (!is2stuks) {
      _state.k1 = '';
      _state.k2 = '';
      ui.querySelectorAll('.bybloom-kleur-btn').forEach(function(b) {
        b.classList.remove('bybloom-kleur-btn--gekozen');
        b.setAttribute('aria-pressed', 'false');
      });
    }
  }

  function setupTwoColorPickerForPicker(picker) {
    var pid = getPickerId(picker);
    var fs  = findFieldsets(picker);
    if (!fs.kleurFs || !fs.aantalFs) return;

    hideGemengdOption(fs);

    var uiId = 'bybloom-twee-kleuren-' + pid;
    if (!document.getElementById(uiId)) {
      var ui = document.createElement('div');
      ui.id = uiId;
      ui.style.display = 'none';
      ui.innerHTML = buildTwoColorHTML();
      picker.parentNode.insertBefore(ui, picker.nextSibling);

      ui.addEventListener('click', function (e) {
        var btn = e.target.closest('.bybloom-kleur-btn');
        if (!btn) return;
        var group = btn.dataset.group;
        var kleur = btn.dataset.kleur;

        ui.querySelectorAll('.bybloom-kleur-btn[data-group="' + group + '"]').forEach(function (b) {
          b.classList.remove('bybloom-kleur-btn--gekozen');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('bybloom-kleur-btn--gekozen');
        btn.setAttribute('aria-pressed', 'true');

        if (group === '1') _state.k1 = kleur;
        if (group === '2') _state.k2 = kleur;
      });
    }

    syncVisibilityForPicker(picker);
  }

  function initPicker(picker) {
    injectBadgesForPicker(picker);
    setupTwoColorPickerForPicker(picker);

    var morphObs = new MutationObserver(function (mutations) {
      var isOwnChange = mutations.every(function (m) {
        return Array.from(m.addedNodes).concat(Array.from(m.removedNodes)).every(function (node) {
          return node.nodeType === 1 && node.classList && node.classList.contains(BADGE_CLASS);
        });
      });
      if (isOwnChange) return;
      picker.querySelectorAll('.' + BADGE_CLASS).forEach(function (b) { b.remove(); });
      picker.querySelectorAll('fieldset').forEach(function (fs) {
        if (fs.style.paddingTop === '24px') fs.style.paddingTop = '';
      });
      setTimeout(function () {
        injectBadgesForPicker(picker);
        syncVisibilityForPicker(picker);
      }, 80);
    });
    morphObs.observe(picker, { childList: true, subtree: true });
  }

  document.addEventListener('change', function (e) {
    if (!e.target || e.target.type !== 'radio') return;
    if ((e.target.value || '').indexOf('stuk') !== -1) {
      var picker = e.target.closest('variant-picker');
      if (picker) syncVisibilityForPicker(picker);
    }
  });

  var domObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var pickers = node.tagName && node.tagName.toLowerCase() === 'variant-picker'
          ? [node]
          : (node.querySelectorAll ? Array.from(node.querySelectorAll('variant-picker')) : []);
        pickers.forEach(function (p) { setTimeout(function () { initPicker(p); }, 100); });
      });
    });
  });

  function initAll() {
    document.querySelectorAll('variant-picker').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('DOMContentLoaded', function () {
    domObserver.observe(document.body, { childList: true, subtree: true });
  });

})();
